import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "live-translate",
  courseId: "getting-started",
  order: 7,
  title: "Live Translate",
  summary:
    "Two-way spoken translation on your iPhone. Each side taps to talk, the phone speaks the translation, and the whole conversation becomes case media.",
  learn: [
    "Set the two languages and run a conversation",
    "Use Auto-detect and the Show view",
    "Review, correct, and send the session to a case",
  ],
  minutes: 4,
  releasedAt: "2026-10-17T00:00:00.000Z",
  platform: "ios",
  body: [
    {
      type: "paragraph",
      text: "When you need to talk with someone who does not speak your language, Live Translate opens straight into translating. You pick your language and the subject's, and the subject never handles the phone. One continuous recording runs from the first tap to End, so the session is a single audio file with every turn marked.",
    },
    { type: "heading", text: "Run a conversation" },
    {
      type: "steps",
      items: [
        "Open Live Translate from the app.",
        "Choose your language and theirs in the language bar.",
        "Check the readiness line under the bar.",
        "Tap your talk button to start a turn, and tap it again to end the turn.",
        "Tap Pause to stop recording briefly, or End to finish.",
        "Choose a destination: a new case, an existing case, or Files.",
      ],
    },
    {
      type: "bullets",
      items: [
        "Green: the pair works offline.",
        "Amber \"Online translation\": a **Download** button is offered.",
        "Red \"No signal\": turns will be translated when you upload.",
      ],
    },
    {
      type: "paragraph",
      text: "The talk button is labelled in each language (for example \"Toca para hablar\"). When a turn ends, the text and the translation appear and the phone speaks it.",
    },
    { type: "heading", text: "Auto-detect and Show view" },
    {
      type: "steps",
      items: [
        "Turn on **Auto-detect** above the buttons to let the phone work out who is speaking.",
        "If it guesses wrong, swipe the bubble to the other side or tap Switch under it.",
        "Switch to Show view to display your latest line in the subject's language in large type.",
      ],
    },
    {
      type: "paragraph",
      text: "Show view has Play and Flip, for someone facing you.",
    },
    {
      type: "callout",
      tone: "warning",
      title: "Rough translation",
      text: "Offline packs for languages Apple does not support on-device (Tagalog, Punjabi) are marked \"rough translation\". Use them to communicate on scene. The server re-translates those turns when the session uploads.",
    },
    { type: "heading", text: "Review" },
    {
      type: "paragraph",
      text: "After End, the Review screen plays the recording with each turn highlighted as it is heard. Tap Edit on the transcript heading to fix text, and use the speaker arrows to move a turn to the other side. Then send.",
    },
    {
      type: "callout",
      tone: "note",
      title: "What the case gets",
      text: "The session is saved as an interaction file with you as one speaker and the subject as the other, in your language with the original alongside. Sending to an existing case regenerates its narrative from all media.",
    },
  ],
  related: ["the-mobile-app", "narrative-vs-interaction-audio"],
};

export default lesson;
